import { useMutation } from '@tanstack/react-query';
import { purchaseCredits } from '../../services/marketing';
import { PurchaseCreditsPayload } from '../../types/marketing';
import useUser from '../global/useUser';

type MutationPayload = Omit<PurchaseCreditsPayload, 'businessId'>;

interface Options {
  onMutate?: (variables: MutationPayload) => void;
  onSuccess?: (data: Awaited<ReturnType<typeof purchaseCredits>>) => void;
  onError?: (error: Error) => void;
  onSettled?: () => void;
}

export function usePurchaseCredits(options: Options = {}) {
  const { user } = useUser();

  return useMutation({
    mutationFn: async (payload: MutationPayload) => {
      if (!user?.business?.id) throw new Error('Business is required');

      const result = await purchaseCredits({
        ...payload,
        businessId: user?.business?.id,
      });

      if (!result || result.status !== 'SUCCESS') {
        throw new Error('Failed to purchase credits');
      }

      return result;
    },
    ...options,
  });
}
